import { DefineGetters } from "vuex-type-helper";
import { SocketIOGetters, SocketIOState } from "./types";

export const getters: DefineGetters<SocketIOGetters, SocketIOState> = {};
